/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetSyndigoSyncStatusQueryResponse,
  GetSyndigoSyncStatus400,
} from '../types/GetSyndigoSyncStatus'

function getGetSyndigoSyncStatusUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/variants/syndigo/sync-status/` as const,
  }
  return res
}

/**
 * @description Get Syndigo sync status information.
 * GET /variants/syndigo/sync-status/
 * Returns:
 * Response with sync status data including:
 * - status: Current sync status
 * - lastSyncAt: Timestamp of most recent sync
 * - lastFullSyncAt: Timestamp of most recent full sync
 * - lastIncrementalOrSingleSyncAt: Timestamp of most recent incremental/single sync
 * @summary Get Syndigo sync status
 * {@link /api/v1/products/catalog/variants/syndigo/sync-status/}
 */
export async function getSyndigoSyncStatus(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetSyndigoSyncStatusQueryResponse,
    ResponseErrorConfig<GetSyndigoSyncStatus400>,
    unknown
  >({
    method: 'GET',
    url: getGetSyndigoSyncStatusUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
